import { Card } from '@/components/ui'
import { ChartMode, ChartView, ConversionWindow } from '@/hooks/useChartData'
import { ChartLegend, ChartHeader, ButtonGroup, VolumeChart, ConversionChart, RevenueChart } from '@/components/analytics'
import { VOLUME_VIEW_OPTIONS, CONVERSION_WINDOW_OPTIONS, CHART_MODE_OPTIONS, REVENUE_VIEW_OPTIONS } from './chartOptions'

interface LegendItem {
  key: string
  label: string
  color: string
}

export interface AnalyticsChartsSectionProps {
  chartData: any[]
  chartMode: ChartMode
  chartView: ChartView
  conversionWindow: ConversionWindow
  visibleLines: Record<string, boolean>
  planData: any
  currency?: string
  volumeLegendItems: LegendItem[]
  conversionLegendItems: LegendItem[]
  onChartModeChange: (value: ChartMode) => void
  onChartViewChange: (value: ChartView) => void
  onConversionWindowChange: (value: ConversionWindow) => void
  onToggleVisibleLine: (key: string) => void
}

export function AnalyticsChartsSection({
  chartData,
  chartMode,
  chartView,
  conversionWindow,
  visibleLines,
  planData,
  currency = 'RUB',
  volumeLegendItems,
  conversionLegendItems,
  onChartModeChange,
  onChartViewChange,
  onConversionWindowChange,
  onToggleVisibleLine
}: AnalyticsChartsSectionProps) {
  if (chartData.length === 0) return null

  return (
    <>
      <Card>
        <ChartHeader title={chartMode === 'volume' ? 'Динамика по этапам продаж' : 'Конверсии по этапам продаж'}>
          {chartMode === 'volume' && (
            <ButtonGroup
              options={VOLUME_VIEW_OPTIONS}
              value={chartView}
              onChange={(value) => onChartViewChange(value as ChartView)}
              variant="success"
            />
          )}
          {chartMode === 'conversion' && (
            <ButtonGroup
              options={CONVERSION_WINDOW_OPTIONS}
              value={conversionWindow.toString()}
              onChange={(value) => onConversionWindowChange(parseInt(value, 10) as ConversionWindow)}
              variant="info"
            />
          )}
          <ButtonGroup
            options={CHART_MODE_OPTIONS}
            value={chartMode}
            onChange={(value) => onChartModeChange(value as ChartMode)}
          />
        </ChartHeader>
        {chartMode === 'volume' ? (
          <VolumeChart
            chartData={chartData}
            chartView={chartView}
            planData={planData}
            visibleLines={visibleLines}
          />
        ) : (
          <ConversionChart
            chartData={chartData}
            visibleLines={visibleLines}
          />
        )}
        <ChartLegend
          items={chartMode === 'volume' ? volumeLegendItems : conversionLegendItems}
          visibleItems={visibleLines}
          onToggle={onToggleVisibleLine}
        />
      </Card>

      <Card>
        <ChartHeader title="Динамика выручки">
          <ButtonGroup
            options={REVENUE_VIEW_OPTIONS}
            value={chartView}
            onChange={(value) => onChartViewChange(value as ChartView)}
            variant="success"
          />
        </ChartHeader>
        <RevenueChart
          chartData={chartData}
          chartView={chartView}
          planData={planData}
          visibleLines={visibleLines}
          currency={currency}
        />
        <ChartLegend
          items={[
            { key: 'revenue', label: 'Выручка всего', color: '#4CAF50' },
            { key: 'newRevenue', label: 'Выручка по новым', color: '#2196F3' },
            { key: 'existingRevenue', label: 'Выручка по не новым', color: '#FF9800' }
          ]}
          visibleItems={visibleLines}
          onToggle={onToggleVisibleLine}
        />
      </Card>
    </>
  )
}
